// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import packageInfo from '../../package.json';

export const environment = {
  appVersion: packageInfo.version,
  production: false,
  apiUrl: 'http://localhost:9999/api',
  showdemo: false,
  ehoweyaAuthorizeUrl: 'https://193.95.63.241:8443/oauth2/authorize',
  BACK_END_POINT:'http://localhost:9999/',
  icons_url :"https://mas.devnumeryx.fr",
  turnstileEnforce: true,
  turnstileEnabled: true,
  turnstileSiteKey: '0x4AAAAAAFQecYFLIDz_Ag6Y'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
